export default {
  SET_STATE: 'posts/SET_STATE',
  FETCH_POSTS: 'posts/FETCH_POSTS',
  CREATE_POST: 'posts/CREATE_POST',
  FETCH_SINGLE: 'posts/FETCH_SINGLE',
  UPDATE_POST: 'posts/UPDATE_POST',
  PERFORM_ACTION_POST: 'posts/PERFORM_ACTION_POST',
}
